<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Products</h4>
              <p class="category">List of products available</p>
              <br>
           
              <div style="margin-bottom: 10px">
                <el-row>
                  <el-col :span="8">
                    Filter by Type:    <el-select v-model="filters[0].value" placeholder="select type">
                    <el-option label="Download" value="download"></el-option>
                    <el-option label="Combined" value="combined course"></el-option>
                    <el-option label="Online" value="online course"></el-option>
                    <el-option label="Classroom" value="classroom course"></el-option>
                    <el-option label="Extension" value="online extension"></el-option>
                    <el-option label="Course Extra" value="course extra"></el-option>
                    <el-option label="Extra" value="extras"></el-option>
                    <el-option label="Bundle" value="bundle"></el-option>
              
                  </el-select>
                  Bundles Only <el-checkbox v-model="filters[1].value" value="false"></el-checkbox>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-if="error">{{error}}</div>
            <div class="table-responsive">
              <data-tables-server  class="table-shopping" style="width: 100%" 
              :data="products"  
              @query-change="getProducts"
              :filters="filters" 
                v-loading="loadingProducts"
                element-loading="Loading Products please wait..."
                element-loading-spinner="el-icon-loading"
                >
                <el-table-column label="ID" min-width="90">
                  <template slot-scope="props">{{props.row.id}}</template>
                </el-table-column>
                <el-table-column label="Product Name" min-width="350">
                  <template slot-scope="props">{{props.row.name}}</template>
                </el-table-column>
                <el-table-column label="Bundle" min-width="90">
                  <template slot-scope="props"><el-checkbox disabled v-model="props.row.isBundle"></el-checkbox></template>
                </el-table-column>
                <el-table-column label="Course Type" min-width="120">
                  <template slot-scope="props">{{props.row.type}}</template>
                </el-table-column>
                <el-table-column label="Available on site" min-width="150">
                  <template slot-scope="props">
                      <small class="label label-danger" v-if="props.row.isPublic === 0"><i class="fa fa-times"></i> No</small>
                      <small class="label label-success" v-if="props.row.isPublic === 1"><i class="fa fa-check"></i> Yes</small>
                    </template>
                </el-table-column>
                <el-table-column label="Edit Product" min-width="120">
                  <template slot-scope="props">
                    <router-link :to="'/product/edit/'+props.row.id">Edit</router-link>
                  </template>
                </el-table-column>
              </data-tables-server>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
import api from "./api";
import { debug } from 'util';
import _ from 'lodash';
export default {
  data() {
    return {
        loadingProducts:false,
        error:null,
        total:0,
        selectedProduct:'',
        products:[],
        variants:[],
        titles:[
          {
            prop: "id",
            label: "ID"
          },
          {
            prop: "name",
            label: "Product Name"
          },
          {
            prop: "cost",
            label: "Price"
          },
          {
            prop: "isBundle",
            label: "Bundle"
          },
          {
            prop: "prices",
            label: "Prices"
          }
        ],
        filters: [
        {
          value: "download",
          prop:"type"
        },
        {value:false,
          prop:"isBundle"
        }
      ],
    }
  },
  methods: {
      getProducts(queryInfo) { 
        console.log("FILTERS",queryInfo)
        var where=null;
        if ( queryInfo.filters != undefined ) {
        where = `,where:{${queryInfo.filters[0].prop}:{_eq:"${queryInfo.filters[0].value}"},${queryInfo.filters[1].prop}:{_eq:"${queryInfo.filters[1].value}"}}`
        }
        this.loadingProducts = true;
        this.$apollo
          .query({
            query: gql`
                        {
              Product(order_by: {id: asc}${where?where:''}) {
                name
                id
                type
                isPublic
                isBundle
                prices(where: {dateTo: {_eq: "2090-01-01"}}){
                  cost
                }
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
        })
        .then(response => {
          this.products = response.data.Product;
          this.loadingProducts = false;
        })
      }
  },

    watch: {
    "$route.params.value": function(value) {
      this.getProducts();
    }
  },

  mounted() {
    this.getProducts();
  }
}


</script>


// WEBPACK FOOTER //
// src/components/Products/List.vue